import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getRsswSitemapList } from "@store/Services/RsswSitemapService";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";

export interface GetRsswSitemapResultModel {
    result?: string;
}

interface Props extends StoreHandlerProps {
    apiResult: GetRsswSitemapResultModel;
}

type HandlerType = Handler<{}, Props>;

export const GetRsswSitemap: HandlerType = async props => {
    props.apiResult = await getRsswSitemapList();
};

export const chain = [GetRsswSitemap];

const getRsswSitemap = createHandlerChainRunner(chain, "GetRsswSitemap");
export default getRsswSitemap;
